import React, { useState, useMemo } from 'react';
import { withThemeProvider } from '../utils/withThemeProvider';
import { TemplateTableProps } from './types.d';
import EmailPreviewModal from './subComponents/EmailPreviewModal';
import DesktopView from './subComponents/DesktopView';
import TabletView from './subComponents/TabletView';
import MobileView from './subComponents/MobileView';

const TemplateTable: React.FC<TemplateTableProps> = ({
  templates,
  loading,
  templateTypes = [],
  onEdit,
  onDuplicate,
  onSetDefault,
  onDelete,
  onTestEmail,
}) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handlePreview = (template: any) => {
    setSelectedTemplate(template);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setSelectedTemplate(null);
  };

  const viewProps = useMemo(
    () => ({
      templates,
      templateTypes,
      onEdit,
      onDuplicate,
      onSetDefault,
      onDelete,
      onPreview: handlePreview,
      onTestEmail,
      loading,
    }),
    [templates, templateTypes, onEdit, onDuplicate, onSetDefault, onDelete, onTestEmail, loading]
  );

  return (
    <>
      <div style={{ display: 'none' }} className="desktop-view">
        <DesktopView {...viewProps} />
      </div>

      <div style={{ display: 'none' }} className="tablet-view">
        <TabletView {...viewProps} />
      </div>
      <div style={{ display: 'none' }} className="mobile-view">
        <MobileView {...viewProps} />
      </div>

      <style>{`
        @media (min-width: 1024px) {
          .desktop-view {
            display: block !important;
          }
          .tablet-view,
          .mobile-view {
            display: none !important;
          }
        }

        @media (min-width: 768px) and (max-width: 1023px) {
          .desktop-view,
          .mobile-view {
            display: none !important;
          }
          .tablet-view {
            display: block !important;
          }
        }

        @media (max-width: 767px) {
          .desktop-view,
          .tablet-view {
            display: none !important;
          }
          .mobile-view {
            display: block !important;
          }
        }
      `}</style>

      <EmailPreviewModal isOpen={isPreviewOpen} onClose={handleClosePreview} template={selectedTemplate} />
    </>
  );
};

export const TemplateTableWithTheme = withThemeProvider(TemplateTable);

export default TemplateTable;
